import { render, staticRenderFns } from "./Resellers.vue?vue&type=template&id=452853a4&scoped=true"
import script from "./Resellers.vue?vue&type=script&lang=js"
export * from "./Resellers.vue?vue&type=script&lang=js"
import style0 from "./Resellers.vue?vue&type=style&index=0&id=452853a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452853a4",
  null
  
)

export default component.exports